import React from "react";

export const isActivationKey = (event: React.KeyboardEvent): boolean => {
  return event.key === "Enter" || event.key === " ";
};
